import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Subject } from 'rxjs/internal/Subject';
import { LanguageEnum } from '../shared/models/item.model';


@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  language: BehaviorSubject<boolean> =  new BehaviorSubject<boolean>(false);
  bgvarSubject = new Subject<any>();
  languageChange = new EventEmitter<LanguageEnum>();

  constructor(private router: Router,
              private translate: TranslateService) {
    this.applyDocumentLanguage(this.getCurrentLanguage());
  }

  toggle(): void{
      localStorage.setItem('exab-lang', this.language.value !== false ? 'ar' : 'en'); //
      this.language.next(!this.language.value);
      this.language.value === false ? this.translate.use('ar') : this.translate.use('en');
      const language = this.language.value === false ? LanguageEnum.ar : LanguageEnum.en;
      this.applyDocumentLanguage(language);
      this.languageChange.emit(language);
  }

  /**
   * Keeps the document language and reading direction in step with the chosen language, so the
   * whole page flips instead of only the components that bind [dir] themselves.
   */
  private applyDocumentLanguage(language: LanguageEnum): void {
    const isArabic = language === LanguageEnum.ar;
    document.documentElement.lang = isArabic ? 'ar' : 'en';
    document.documentElement.dir = isArabic ? 'rtl' : 'ltr';
  }

  togglebg(value: any): void{
    this.bgvarSubject.next(value);
  }

  getCurrentLanguage(): LanguageEnum {
    let lang = localStorage.getItem('exab-lang');
    if(lang === null) return LanguageEnum.ar;
    return lang === 'ar' ? LanguageEnum.ar : LanguageEnum.en ;
    // return this.translate.currentLang === 'ar'? LanguageEnum.ar: LanguageEnum.en ;
  }
}
